import React, {Fragment, useState} from 'react';
import {Link, withRouter} from 'react-router-dom';

import createLink from "../../../../libs/createLink";

import Dropdown from '../../../components/Dropdown';
import Avatar from '../../../components/Avatar';
import Icon from '../../../components/Icon';
import Alert from "../../../components/Alert";
import RoomAddUser from "./RoomAddUser";
import RoomChangeGroupTitle from "./RoomChangeGroupTitle";
import Modal from "../../../components/Modal";
import _ from "lodash";
import {Button} from "../../../components/Button";
import {Can} from "../../../../ability-context";
import {durationVideo} from "../../../../libs/helper";

const RoomProfile = ({
                         mobile = false,
                         room = {},
                         medias = [],
                         mediasMore = false,
                         currentUser = {},
                         handleUserLeave = () => {
                         },
                         handleRoomLock = () => {
                         },
                         handleRoomArchived = () =>{
                         },
                         handleAddUser = () => {
                         },
                         handleChangeGroupTitle = () => {
                         },
                         handleRoomMarkRead = () => {
                         },
                         handleOpenMedia = () => {
                         },
                         handleMediaMore = () => {
                             console.log("non ?");
                         },
                         handleRemoveRoom = () =>{
                         },
                         ...props
                     }) => {
    let [toggleChangeGroupTitle, setToggleChangeGroupTitle] = useState(false);
    let [toggleAlertLeave, setToggleAlertLeave] = useState(false);
    let [leaveUserId, setLeaveUserId] = useState(null);
    let [alertLeaveForCurrentUser, setAlertLeaveForCurrentUser] = useState(false);
    let [toggleAddUser, setToggleAddUser] = useState(false);
    let [toggleRemoveRoom, setToggleRemoveRoom] = useState(false);

    const _handleUserLeaveAlert = (userId, isGroup) => {
        setAlertLeaveForCurrentUser(!!isGroup);
        setToggleAlertLeave(true);
        setLeaveUserId(userId);
    }
    const _handleUserLeave = (canceled) => {
        setToggleAlertLeave(false);
        if (!canceled) handleUserLeave(leaveUserId);
        setLeaveUserId(null);
    }

    const _handleAddUser = (userId) => {
        setToggleAddUser(false);
        handleAddUser(userId);
    }

    const _handleChangeGroupTitle = (title) => {
        setToggleChangeGroupTitle(false);
        handleChangeGroupTitle(title);
    }

    const _handleRoomLock = () => {
        if (!room.locked || room.currentUserIsLocker) handleRoomLock();
    }


    let roomUsersId = room.users.map(user => user._id);

    const _stateToString = (state = 0) => {
        let stateStr = [
            'En attente d\'encodage',
            "",
            'Encodage en cours',
            "Erreur d'encodage",
            'Encodage en cours'
        ];
        return stateStr[state];
    }



    return (
        <div className="profil-card">
            <div className="card">
                <div className="topline">
                    {!!mobile && (
                        <div className={"responsive-btn"}
                             onClick={() => props.history.goBack()}><Icon type={"arrow-left"}/>
                        </div>
                    )}
                    <div className="wrapper-topline">
                        {
                            room.isGroup
                                ? <Avatar avatar={room.users.map(user => _.get(user, "profile.avatar"))}/>
                                : <Avatar avatar={_.get(room.participantsWithoutCurrent, "[0].profile.avatar")}
                                          gender={_.get(room.participantsWithoutCurrent, "[0].profile.gender")}/>
                        }
                        <div className="topline-infos">
                            <div className="username-list">
                                {room.isGroup && room.groupName
                                    ? room.groupName
                                    : room.users.map((user, index) => <span key={index}
                                                                            className="username">{user.username}</span>)
                                }
                            </div>
                        </div>
                    </div>
                    {room.isGroup && (
                    <Can action="update" subject={"Room"}>
                        <div className="settings-icon">
                            <Dropdown align="right" activableComponent={(
                                <Icon type="cog"/>
                            )}>
                                <div className="dropdown-menu">

                                        <Fragment>
                                            {!room.isLocked && (
                                                <li onClick={() => setToggleChangeGroupTitle(true)}
                                                    className="menu-item"><Icon type="pencil"/> Changer le nom du groupe
                                                </li>)
                                            }
                                            <li className="menu-item"
                                                onClick={() => _handleUserLeaveAlert(currentUser._id)}><Icon
                                                type="sign-out"/> {room.currentUserIsOwner ? `Dissoudre le groupe` : `Quitter la conversation`}
                                            </li>
                                        </Fragment>

                                    {/*!room.isLocked && (
                                        <li className="menu-item"
                                            onClick={() => handleRoomMarkRead(!room.isReadByCurrentUser)}>
                                            {room.isReadByCurrentUser ? (
                                                <span><Icon type={"envelope-o"}/> Marquer comme non lue</span>
                                            ) : (
                                                <span><Icon type={"envelope-o"}/> Marquer comme lue</span>
                                            )}
                                        </li>
                                    )*/}
                                </div>
                            </Dropdown>
                        </div>
                    </Can>)}
                </div>
                {room.isGroup ? (
                    <Fragment>
                        <div className="user-list">
                            <div className="title">Listes des utilisateurs</div>
                            {!room.isLocked && (
                                <Can action="update" subject={"Room"}>
                                    <div className="add-user-to-group"
                                         onClick={() => setToggleAddUser(true)}>
                                        Ajouter un utilisateur <Icon type="plus"/>
                                    </div>
                                </Can>
                            )}
                            {room.users.map(user => {
                                return (
                                    <div key={user._id} className="user">
                                        <Link to={createLink("userProfile", user)}>
                                            <Avatar avatar={user.profile.avatar} gender={user.profile.gender}/>
                                            <span className="username">{user.username}</span>
                                            {room.owner._id === user._id &&
                                            <span className="creator">Propriétaire</span>}
                                        </Link>
                                        {room.currentUserIsOwner &&
                                        <span className="delete-of-group"
                                              onClick={() => _handleUserLeaveAlert(user._id, true)}>
                                                <Icon type="minimize"/>
                                            </span>
                                        }
                                    </div>
                                )
                            })}
                        </div>
                    </Fragment>
                ) : (
                    <div className="group-list">
                        <Can action="update" subject={"Room"}>
                            <div className="list ">
                                <div className="group">
                                    <Icon type={"plus"}/>
                                    <Link className={"title-list"}
                                          to={{
                                              pathname: createLink("messengerCreate"),
                                              query: {users: [room.participantsWithoutCurrent[0]]}
                                          }}>Ajouter un  utilisateur </Link>
                                </div>
                            </div>
                        </Can>
                        <Link to={createLink("userProfile", room.participantsWithoutCurrent[0])} target={"_blank"}
                              rel="noopener noreferrer">
                            <div className="list">
                                <div className="group">
                                    <Icon type="user-o"/>
                                    <div className="title-list">Voir le profil</div>
                                </div>
                                <Icon type="chevron-right"/>
                            </div>
                        </Link>
                        <Can action="update" subject={"Room"}>
                            <div className="list">
                                <div className="group">
                                    <Icon type="ban"/>
                                    <div className="title-list"
                                         onClick={() => _handleRoomLock()}>
                                        {room.isLocked ? (room.currentUserIsLocker ? "Débloquer la conversation" : "La conversation est bloquée") : "Bloquer la conversation"}
                                    </div>
                                </div>
                            </div>
                        </Can>
                        <Can action="update" subject={"Room"}>
                            <div className="list">
                                <div className="group">
                                    <Icon type="archive"/>
                                    <div className="title-list"
                                         onClick={() => handleRoomArchived(!room.currentUserIsArchived)}>
                                        {room.currentUserIsArchived ? "Restaurer" : "Archiver"}
                                    </div>
                                </div>
                            </div>
                        </Can>
                        <Can action="delete" subject={"Room"}>
                            <div className="list">
                                <div className="group">
                                    <Icon type="trash"/>
                                    <div className="title-list"
                                         onClick={() => setToggleRemoveRoom(true)}>
                                         Effacer la conversation
                                    </div>
                                </div>
                            </div>
                        </Can>
                    </div>
                )}
                {medias.length >= 1 && (
                    <div className="media-attachement">
                        <div className="title">Medias partagés</div>
                        <div className="media-container">
                            {medias.map(item => (
                                <div className="img-container"
                                     key={item._id}
                                     style={{backgroundImage: `url(${item.previewUrl}?width=200)`}}
                                     onClick={() => handleOpenMedia(item._id)}
                                >
                                    {item.kind === "video" ? (
                                        <div className={"informations-media"} >
                                            {item.kind === "video" && _.get(item, "file.state") === 1 ? <div className={"duration"}><Icon type="play"/> {durationVideo(_.get(item, "file.duration") || 0)}</div> : <div className="thumb-status">{_stateToString(_.get(item, "file.state") || 0)}</div>}
                                        </div>
                                    ) : null}
                                </div>
                            ))}
                        </div>
                        {mediasMore && (
                            <Button btnStyle="primary-reverse"
                                    size="small"
                                    className="full m-8"
                                    onClick={handleMediaMore}
                                    content="Voir plus"/>
                        )}
                    </div>
                )}
            </div>
            <Modal toggle={toggleAlertLeave}
                   handleClose={() => _handleUserLeave(true)}>
                <Alert
                    text={leaveUserId === _.get(room, 'owner._id') ? 'Souhaitez-vous dissoudre ce groupe ?' : (alertLeaveForCurrentUser && leaveUserId === _.get(room, 'owner._id') ? 'Voulez vous vraiment quitter ce groupe ?' : 'Voulez vous vraiment retirer cette personne du groupe ?')}
                    handleClose={() => _handleUserLeave(true)}
                    handleDelete={() => _handleUserLeave()}/>
            </Modal>
            <Modal toggle={toggleRemoveRoom}
                   handleClose={() => setToggleRemoveRoom(false)}>
                <Alert
                    text={"Tous vos messages dans cette conversation seront supprimés. Souhaitez-vous continuer ?"}
                    handleClose={() => setToggleRemoveRoom(false)}
                    handleDelete={() => handleRemoveRoom(room._id)}/>
            </Modal>
            <Modal toggle={toggleChangeGroupTitle}
                   handleClose={() => setToggleChangeGroupTitle(false)}>
                <RoomChangeGroupTitle
                    groupTitle={room.groupName}
                    handleClose={() => setToggleChangeGroupTitle(false)}
                    handleSubmit={_handleChangeGroupTitle}
                />
            </Modal>
            <Modal toggle={toggleAddUser}
                   handleClose={() => setToggleAddUser(false)}>
                <RoomAddUser usersIds={roomUsersId}
                             currentUser={currentUser}
                             handleAddUser={_handleAddUser}
                             handleClose={() => setToggleAddUser(false)}/>
            </Modal>
        </div>
    )
}

export default withRouter(RoomProfile);
